import { EndScreen } from './end-screen';
import { EndScreenType } from './end-screen-types';

interface EndScreenHtmlConfig {
  skin?: {
    endScreenHtml?: string;
  };
  endScreen?: {
    closeBtn?: {
      delay?: number;
      size?: number;
    };
  };
  closeBtn?: {
    autoCloseDelay?: number;
  };
}

export class EndScreenHtml extends EndScreen {
  content: string;

  constructor({ config }: { config: EndScreenHtmlConfig }) {
    super({ config });
    this.content = (config && config.skin && config.skin.endScreenHtml) || '';
    this.type = EndScreenType.HTML;
  }

  isValid(): boolean {
    return Boolean(this.content) && this.duration > 0;
  }
}
